import { render, staticRenderFns } from "./Panduan.vue?vue&type=template&id=1aa0fcc8&"
import script from "./Panduan.vue?vue&type=script&lang=js&"
export * from "./Panduan.vue?vue&type=script&lang=js&"
import style0 from "./Grid.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports